import React, { Fragment, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import { Alert, Popconfirm, Button } from 'antd';
import WhatsappIntegrationActions from '@Actions/integrations/whatsappIntegrationActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { SettingOutlined } from '@ant-design/icons';
import WhatsappTnC from '../WhatsappTnC';

const WhatsappHome = ({
  user, getWhatsappConnections, whatsappConnections, getWhatsappConnectionsLoading, toggleWhatsapp, history, toggleWhatsappLoading,
}) => {
  const [isUserAllReadyConnected, setIsUserAllReadyConnected] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getWhatsappConnections(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    if (whatsappConnections?.tandc_accepted && whatsappConnections?.whatsapp_enabled && whatsappConnections?.tenant_integrations?.length > 0) {
      setIsUserAllReadyConnected(true);
    } else if (whatsappConnections?.tandc_accepted && whatsappConnections?.whatsapp_enabled && whatsappConnections?.tenant_integrations?.length === 0) {
      history.push('/admin/integration/whatsapp/setup');
    } else {
      setIsUserAllReadyConnected(false);
    }
  }, [whatsappConnections]);

  const toggleWhatsappIntegration = () => {
    const payload = {
      org_id: user?.tenant_info?.org_id,
      whatsapp_enabled: false,
      tandc_accepted: false,
    };
    toggleWhatsapp(payload, () => {
      history.push('/admin/integration');
    });
  };

  return (
    <div className="whatsapp-integration-wrapper">
      <div className="whatsapp-integration__heading">Whatsapp Integration</div>
      <Fragment>
        { !getWhatsappConnectionsLoading ? (
          <Fragment>
            {isUserAllReadyConnected === true && (
              <Fragment>
                <div className="whatsapp-list-wrapper">
                  <Alert
                    message="You can only deactivate WhatsApp integration. To make changes to the configuration, please visit the business profile page."
                    showIcon
                  />
                  <div className="flex-display flex-align-c" style={{ width: '100%', marginTop: '10px' }}>
                    <div>
                      <Popconfirm
                        open={open}
                        onOpenChange={() => setOpen(!open)}
                        placement="topRight"
                        title="Are you sure you want to deactivate whatsapp?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => toggleWhatsappIntegration()}
                      >
                        <Button danger>Deactivate</Button>
                      </Popconfirm>
                    </div>
                    <div style={{ marginLeft: '10px' }}>
                      <Link to="/admin/integration/whatsapp/setup">
                        <Button type="primary" ghost>
                          <SettingOutlined orgConfiguration={whatsappConnections?.org_configuration} />
&nbsp;Reconfigure
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
            {isUserAllReadyConnected === false
            && (
              <Fragment>
                <div className="whatsapp-integration__body">
                  <WhatsappTnC />
                </div>
              </Fragment>
            )}
          </Fragment>
        ) : (
          <div
            className="whatsapp-list-wrapper"
          >
            {
              [1].map((item) => (
                <div
                  key={item}
                  className="loading-whatsapp__card"
                >
                  <div className="whatsapp-card-spacing">

                    <div className="whatsapp-card-header">

                      <div className="loadingBlock loading-whatsapp-header__text" />
                      <div className="loadingBlock loading-whatsapp-header__image"> </div>
                    </div>

                    <div className="loadingBlock loading-whatsapp-card__link"> </div>
                    <div className="whatsapp-card-footer">
                      <div
                        className="flex "
                      >
                        <p className="loadingBlock loading-whatsapp-card__footer" />
                      </div>
                    </div>
                  </div>
                </div>

              ))
            }
          </div>
        ) }
      </Fragment>
    </div>
  );
};

const mapStateToProps = ({ UserReducers, WhatsappIntegrationReducers }) => ({
  user: UserReducers.user,
  whatsappConnections: WhatsappIntegrationReducers.whatsappConnections,
  getWhatsappConnectionsLoading: WhatsappIntegrationReducers.getWhatsappConnectionsLoading,
  toggleWhatsappLoading: WhatsappIntegrationReducers.toggleWhatsappLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getWhatsappConnections: (orgId, callback) => dispatch(WhatsappIntegrationActions.getWhatsappConnections(orgId, callback)),
  toggleWhatsapp: (payload, callback) => dispatch(WhatsappIntegrationActions.toggleWhatsapp(payload, callback)),

});
WhatsappHome.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  getWhatsappConnections: PropTypes.func,
  whatsappConnections: PropTypes.any,
  getWhatsappConnectionsLoading: PropTypes.bool,
  toggleWhatsapp: PropTypes.func,
  toggleWhatsappLoading: PropTypes.bool,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WhatsappHome));
